// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBIn_cUHOm9UogcAJ5lQH31TQDhcR-xpig",
    authDomain: "mediservice-9e3dc.firebaseapp.com",
    projectId: "mediservice-9e3dc",
    storageBucket: "mediservice-9e3dc.appspot.com",
    messagingSenderId: "145760234911",
    appId: "1:145760234911:web:7d7f661a12536fd93061aa"
};
export default firebaseConfig;